import {useEffect} from 'react';
import {useSetAtom} from 'jotai';
import {hydrateOfflineQueueAtom} from './offlineQueue';

/** Loads any pending offline mutations from IndexedDB once on app start. */
export function useOfflineQueueHydration() {
   const hydrate = useSetAtom(hydrateOfflineQueueAtom);

   useEffect(() => {
      void hydrate();
   }, [hydrate]);
}
